import { useWindowDimensions } from 'react-native';

/** OS fontScale at or above this value stacks compact checkout rows. */
export const LARGE_FONT_SCALE_THRESHOLD = 1.3;

export function useIsLargeFontScale() {
  const { fontScale } = useWindowDimensions();
  return fontScale >= LARGE_FONT_SCALE_THRESHOLD;
}
